const Role = {
  nationalManager: 'GESTOR_NACIONAL',
  stateManager: 'GESTOR_ESTADUAL',
  judge: 'JURADO',
  minervaJudge: 'JURADO_MINERVA',
} as const;

export const RoleModel = {
  ...Role,

  Manager: [Role.nationalManager, Role.stateManager],
  Any: [Role.nationalManager, Role.stateManager, Role.judge],
};
